import { Link } from "react-router-dom";

const PaymentCancelled = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4">
      <div className="bg-slate-800/60 backdrop-blur-sm rounded-2xl border border-slate-700 shadow-2xl max-w-md w-full p-8 text-center" data-testid="payment-cancelled">
        <div className="w-20 h-20 bg-amber-500 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>
        
        <h2 className="text-2xl font-semibold text-white mb-2">Payment Cancelled</h2>
        <p className="text-slate-400 mb-6">Your payment was cancelled. Your registration has not been completed.</p>
        
        <div className="space-y-3">
          <Link 
            to="/"
            className="block w-full bg-emerald-500 text-white font-semibold py-3 px-6 rounded-xl hover:bg-emerald-600 transition-all"
            data-testid="try-again-btn"
          >
            Try Again
          </Link>
          <a 
            href="mailto:libssorg@gmail.com"
            className="block w-full bg-slate-700 text-white font-semibold py-3 px-6 rounded-xl hover:bg-slate-600 transition-all"
          >
            Need Help? Contact Us
          </a>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelled;
